// extracted by mini-css-extract-plugin
export var numberInputContainer = "_8e-0";
export var startPickingButton = "_8e-1";